export const initialTableData = {
  filterField: "",
  filterSelected: [] as string[],
  filterValues: [] as string[],
  filterShowForm: false,
  searchField: "",
  searchText: "",
  showSearchForm: false,
  sortDirection: "asc",
  sortField: "",
  page: 1,
  pageSize: 25,
  selectedRowKey: "",
  selectedRowValue: "",
  searched: false,
};

//filterValues: [] as string[]
